module.exports = __webpack_public_path__ + "static/img/introduction-top-bg.9885114.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/introduction-top-bg.png
// module id = ztiw
// module chunks = 1